// Pixel data for avatar animation frames
// Each frame is a 16x24 grid. Values:
// 0=transparent, 1=skin, 2=hair, 3=shirt, 4=pants, 5=shoes, 6=outline, 7=highlight

// ===== IDLE TYPING (seated at desk, hands move) =====
export const IDLE_TYPING_FRAMES: number[][][] = [
  // Frame 0: hands on keyboard left position
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,7,7,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  // Frame 1: hands on keyboard right position
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,7,7,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,0,1,0,6,3,3,3,3,6,0,1,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== ALERT STANDING (stands up from desk) =====
export const ALERT_STANDING_FRAMES: number[][][] = [
  // Frame 0: standing upright, exclamation pose
  [
    [0,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,7,7,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,6,1,0,3,3,3,3,3,3,0,1,6,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,6,5,5,0,0,5,5,6,0,0,0,0],
    [0,0,0,0,0,6,6,0,0,6,6,0,0,0,0,0],
  ],
  // Frame 1: looking around
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,6,1,1,6,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,6,1,0,3,3,3,3,3,3,0,1,6,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,6,5,5,0,0,5,5,6,0,0,0,0],
    [0,0,0,0,0,6,6,0,0,6,6,0,0,0,0,0],
  ],
];

// ===== HAPPY WORKING (seated, slight bounce) =====
export const HAPPY_WORKING_FRAMES: number[][][] = [
  // Frame 0: normal seated, smile
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,7,7,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  // Frame 1: slight bounce up (shifted 1px up)
  [
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,7,7,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
];

// ===== CELEBRATING (standing, arms up) =====
export const CELEBRATING_FRAMES: number[][][] = [
  // Frame 0: arms up
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,7,7,7,7,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,1,0,0,0,6,3,3,3,3,6,0,0,0,1,0],
    [0,0,1,0,6,3,3,3,3,3,3,6,0,1,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,6,5,5,0,0,5,5,6,0,0,0,0],
    [0,0,0,0,0,6,6,0,0,6,6,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
  // Frame 1: arms down
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,7,7,7,7,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,0,0,1,6,3,3,3,3,6,1,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,6,5,5,0,0,5,5,6,0,0,0,0],
    [0,0,0,0,0,6,6,0,0,6,6,0,0,0,0,0],
  ],
];

// ===== CELEBRATING BIG (jumping!) =====
export const CELEBRATING_BIG_FRAMES: number[][][] = [
  // Frame 0: jump up, arms way up
  [
    [0,0,7,0,0,0,0,0,0,0,0,0,0,7,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,7,1,1,7,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,7,7,7,7,6,0,0,0,0,0],
    [0,1,0,0,0,0,6,6,6,6,0,0,0,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,1,0,0,0],
    [0,0,0,1,6,3,3,3,3,3,3,6,1,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,6,5,5,0,0,5,5,6,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
  // Frame 1: landing
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,7,1,1,7,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,7,7,7,7,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,1,0,0,0,6,3,3,3,3,6,0,0,0,1,0],
    [0,0,1,0,6,3,3,3,3,3,3,6,0,1,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,6,5,5,0,0,5,5,6,0,0,0,0],
    [0,0,0,0,0,6,6,0,0,6,6,0,0,0,0,0],
  ],
];

// ===== STRESSED (seated, sweat drops) =====
export const STRESSED_FRAMES: number[][][] = [
  // Frame 0: worried face, sweat on left
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,7,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  // Frame 1: sweat on right
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,7,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== STRESSED HEAVY (head down, more sweat) =====
export const STRESSED_HEAVY_FRAMES: number[][][] = [
  // Frame 0: head tilted down
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,7,0,0,6,6,6,6,0,0,7,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  // Frame 1: head more tilted, sweat drops falling
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,7,6,2,2,2,2,2,2,6,7,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== SLUMPED (head on desk) =====
export const SLUMPED_FRAMES: number[][][] = [
  // Frame 0: head down on desk
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,6,6,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,6,6,6,6,6,0,0,0,0,0],
    [0,0,0,6,1,1,3,3,3,3,1,1,6,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  // Frame 1: same but slight "breathing" (tiny shift)
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,6,6,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,6,6,6,6,6,0,0,0,0,0],
    [0,0,0,6,1,1,3,3,3,3,1,1,6,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== WALKING (for manager patrol) =====
export const WALKING_DOWN_FRAMES: number[][][] = [
  // Frame 0: left step
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,0,0,1,3,3,3,3,3,3,1,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,0,0,4,4,6,0,0,0,0],
    [0,0,0,6,4,4,0,0,0,0,4,4,6,0,0,0],
    [0,0,0,6,5,0,0,0,0,0,0,5,6,0,0,0],
    [0,0,0,6,5,0,0,0,0,0,0,5,6,0,0,0],
    [0,0,6,5,5,0,0,0,0,0,0,5,5,6,0,0],
    [0,0,0,6,6,0,0,0,0,0,0,6,6,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
  // Frame 1: right step
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,0,0,1,3,3,3,3,3,3,1,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,0,0,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,0,0,5,6,0,0,0,0,0],
    [0,0,0,0,6,5,5,0,0,5,5,6,0,0,0,0],
    [0,0,0,0,0,6,6,0,0,6,6,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
];

// ===== IDLE TYPING FACING UP (back of head, facing monitor) =====
// Key differences from front: rows 4-7 are ALL hair (no skin/eyes/mouth visible),
// small ear bumps (1=skin) on sides of head, neck goes straight to collar (3=shirt)
export const IDLE_TYPING_UP_FRAMES: number[][][] = [
  // Frame 0: typing left
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  // Frame 1: typing right
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,0,1,0,6,3,3,3,3,6,0,1,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== HAPPY WORKING FACING UP (back of head, slight bounce) =====
export const HAPPY_WORKING_UP_FRAMES: number[][][] = [
  // Frame 0: normal
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  // Frame 1: slight bounce up
  [
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
];

// ===== STRESSED FACING UP (back of head, sweat drops) =====
export const STRESSED_UP_FRAMES: number[][][] = [
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,7,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,7,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== STRESSED HEAVY FACING UP =====
export const STRESSED_HEAVY_UP_FRAMES: number[][][] = [
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,7,0,0,6,6,6,6,0,0,7,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,7,6,2,2,2,2,2,2,6,7,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,3,3,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,1,3,3,3,3,3,3,1,6,0,0,0],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== SLUMPED FACING UP (head on desk, back view - all hair visible) =====
export const SLUMPED_UP_FRAMES: number[][][] = [
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,6,3,3,6,6,0,0,0,0,0],
    [0,0,0,6,1,1,3,3,3,3,1,1,6,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,1,2,2,2,2,2,2,1,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,0,6,6,3,3,6,6,0,0,0,0,0],
    [0,0,0,6,1,1,3,3,3,3,1,1,6,0,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,6,4,4,4,4,4,4,6,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,6,5,5,5,5,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
  ],
];

// ===== SLEEPING (lying in sleeping bag — horizontal, head on right) =====
export const SLEEPING_FRAMES: number[][][] = [
  // Frame 0: sleeping peacefully
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,6,6,6,6,0,0],
    [0,0,0,0,0,0,0,0,0,6,2,2,2,2,6,0],
    [0,0,0,0,0,0,0,0,0,6,1,1,1,1,6,0],
    [0,0,0,0,0,0,0,0,0,6,1,6,6,1,6,0],
    [0,0,0,0,0,0,0,0,0,6,1,1,1,1,6,0],
    [0,0,0,0,0,0,0,0,0,0,6,1,1,6,0,0],
    [0,6,6,6,6,6,6,6,6,6,3,3,3,6,0,0],
    [6,3,3,3,3,3,3,3,3,3,3,3,3,3,6,0],
    [6,3,3,3,3,3,3,3,3,3,3,3,3,3,6,0],
    [6,3,3,3,3,3,3,3,3,3,3,3,3,3,6,0],
    [0,6,6,6,6,6,6,6,6,6,6,6,6,6,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
  // Frame 1: slight breathing motion
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,6,6,6,6,0,0],
    [0,0,0,0,0,0,0,0,0,6,2,2,2,2,6,0],
    [0,0,0,0,0,0,0,0,0,6,1,1,1,1,6,0],
    [0,0,0,0,0,0,0,0,0,6,1,6,6,1,6,0],
    [0,0,0,0,0,0,0,0,0,6,1,1,1,1,6,0],
    [0,0,0,0,0,0,0,0,0,0,6,1,1,6,0,0],
    [0,6,6,6,6,6,6,6,6,6,3,3,3,6,0,0],
    [6,3,3,3,3,3,3,3,3,3,3,3,3,3,6,0],
    [6,3,7,3,3,3,7,3,3,3,3,3,3,3,6,0],
    [6,3,3,3,3,3,3,3,3,3,3,3,3,3,6,0],
    [0,6,6,6,6,6,6,6,6,6,6,6,6,6,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
];

// ===== DANCING (bouncy celebration dance — arms alternating) =====
export const DANCING_FRAMES: number[][][] = [
  // Frame 0: arms up left, lean right
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,7,7,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,1,0,0,6,3,3,3,3,3,3,6,0,0,0,0],
    [1,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,0,3,3,3,3,3,3,0,6,1,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,0,0,4,4,6,0,0,0,0],
    [0,0,0,6,4,0,0,0,0,0,0,4,6,0,0,0],
    [0,0,0,6,5,0,0,0,0,0,0,5,6,0,0,0],
    [0,0,6,5,5,0,0,0,0,0,0,5,5,6,0,0],
    [0,0,0,6,6,0,0,0,0,0,0,6,6,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
  // Frame 1: arms up right, lean left
  [
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,7,7,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,1,0,0],
    [0,0,0,0,6,3,3,3,3,3,3,6,0,0,1,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,1],
    [0,0,1,6,0,3,3,3,3,3,3,0,6,0,0,0],
    [0,0,1,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,0,0,4,4,6,0,0,0,0],
    [0,0,0,6,4,0,0,0,0,0,0,4,6,0,0,0],
    [0,0,0,6,5,0,0,0,0,0,0,5,6,0,0,0],
    [0,0,6,5,5,0,0,0,0,0,0,5,5,6,0,0],
    [0,0,0,6,6,0,0,0,0,0,0,6,6,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
  // Frame 2: arms both up, jump!
  [
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,0,0,0,0,6,2,2,2,2,6,0,0,0,0,0],
    [0,0,0,0,6,2,2,2,2,2,2,6,0,0,0,0],
    [0,0,0,0,6,1,1,1,1,1,1,6,0,0,0,0],
    [0,0,0,0,6,1,6,1,1,6,1,6,0,0,0,0],
    [0,0,0,0,6,1,1,7,7,1,1,6,0,0,0,0],
    [0,0,0,0,0,6,1,1,1,1,6,0,0,0,0,0],
    [0,0,0,0,0,0,6,6,6,6,0,0,0,0,0,0],
    [0,1,0,0,0,6,3,3,3,3,6,0,0,0,1,0],
    [0,0,1,0,6,3,3,3,3,3,3,6,0,1,0,0],
    [0,0,0,6,3,3,3,3,3,3,3,3,6,0,0,0],
    [0,0,0,6,0,3,3,3,3,3,3,0,6,0,0,0],
    [0,0,0,0,0,6,3,3,3,3,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,0,6,4,4,4,4,6,0,0,0,0,0],
    [0,0,0,0,6,4,4,0,0,4,4,6,0,0,0,0],
    [0,0,0,6,4,0,0,0,0,0,0,4,6,0,0,0],
    [0,0,0,6,5,0,0,0,0,0,0,5,6,0,0,0],
    [0,0,6,5,5,0,0,0,0,0,0,5,5,6,0,0],
    [0,0,0,6,6,0,0,0,0,0,0,6,6,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  ],
];

// Map emotional states to their frame arrays
export const ANIMATION_FRAMES: Record<string, number[][][]> = {
  idle_typing: IDLE_TYPING_FRAMES,
  idle_typing_up: IDLE_TYPING_UP_FRAMES,
  alert_standing: ALERT_STANDING_FRAMES,
  happy_working: HAPPY_WORKING_FRAMES,
  happy_working_up: HAPPY_WORKING_UP_FRAMES,
  celebrating: CELEBRATING_FRAMES,
  celebrating_big: CELEBRATING_BIG_FRAMES,
  stressed: STRESSED_FRAMES,
  stressed_up: STRESSED_UP_FRAMES,
  stressed_heavy: STRESSED_HEAVY_FRAMES,
  stressed_heavy_up: STRESSED_HEAVY_UP_FRAMES,
  slumped: SLUMPED_FRAMES,
  slumped_up: SLUMPED_UP_FRAMES,
  walking_down: WALKING_DOWN_FRAMES,
  sleeping: SLEEPING_FRAMES,
  dancing: DANCING_FRAMES,
};

// ===== FEMALE VARIANTS =====
// Detects if a frame has separated legs (standing/walking pose)
function isStandingFrame(frame: number[][]): boolean {
  for (const row of frame) {
    const pLeft = row.indexOf(4);
    const pRight = row.lastIndexOf(4);
    if (pLeft >= 0 && pRight > pLeft) {
      for (let c = pLeft + 1; c < pRight; c++) {
        if (row[c] === 0) return true;
      }
    }
  }
  return false;
}

// Transforms a male frame into a female variant: long hair + skirt
function makeFemaleFrame(frame: number[][]): number[][] {
  const f = frame.map(r => [...r]);
  const standing = isStandingFrame(frame);

  // --- LONG HAIR: extend strands down both sides of the body ---
  let hairBottom = -1;
  for (let r = 0; r < f.length; r++) {
    if (f[r].includes(2)) hairBottom = r;
  }
  if (hairBottom >= 0) {
    for (let r = hairBottom + 1; r <= Math.min(hairBottom + 5, f.length - 1); r++) {
      // Inner strand (col 3 / 12) — closer to body
      if (f[r][3] === 0) f[r][3] = 2;
      if (f[r][12] === 0) f[r][12] = 2;
      // Outer strand (col 2 / 13) — for thickness
      if (f[r][2] === 0) f[r][2] = 2;
      if (f[r][13] === 0) f[r][13] = 2;
    }
  }

  // --- SKIRT: convert pants area ---
  // Find pants-only rows (value 4 present, no shoes value 5)
  const pantsRows: number[] = [];
  for (let r = 0; r < f.length; r++) {
    if (f[r].includes(4) && !f[r].includes(5)) pantsRows.push(r);
  }
  if (pantsRows.length === 0) return f;

  if (standing) {
    // Standing/walking: top 3 rows = skirt, rest = bare legs
    const skirtCount = Math.min(3, pantsRows.length);
    for (let i = 0; i < pantsRows.length; i++) {
      const r = pantsRows[i];
      if (i < skirtCount) {
        let pLeft = f[r].indexOf(4);
        let pRight = f[r].lastIndexOf(4);
        // Fill leg gap with skirt
        for (let c = pLeft; c <= pRight; c++) {
          if (f[r][c] === 0) f[r][c] = 4;
        }
        // Widen skirt
        const widen = Math.min(i + 1, 2);
        if (pLeft > 0 && f[r][pLeft - 1] === 6) f[r][pLeft - 1] = 0;
        if (pRight < 15 && f[r][pRight + 1] === 6) f[r][pRight + 1] = 0;
        for (let w = 1; w <= widen; w++) {
          if (pLeft - w >= 0 && f[r][pLeft - w] === 0) f[r][pLeft - w] = 4;
          if (pRight + w < 16 && f[r][pRight + w] === 0) f[r][pRight + w] = 4;
        }
        const nl = pLeft - widen - 1;
        const nr = pRight + widen + 1;
        if (nl >= 0 && f[r][nl] === 0) f[r][nl] = 6;
        if (nr < 16 && f[r][nr] === 0) f[r][nr] = 6;
      } else {
        // Below skirt: convert pants to skin (bare legs)
        for (let c = 0; c < 16; c++) {
          if (f[r][c] === 4) f[r][c] = 1;
        }
      }
    }
  } else {
    // Seated: progressively widen pants into A-line skirt
    for (let i = 0; i < pantsRows.length; i++) {
      const r = pantsRows[i];
      let pLeft = f[r].indexOf(4);
      let pRight = f[r].lastIndexOf(4);
      if (pLeft < 0) continue;
      const widen = Math.min(Math.ceil(i / 2), 3);
      if (widen > 0) {
        if (pLeft > 0 && f[r][pLeft - 1] === 6) f[r][pLeft - 1] = 0;
        if (pRight < 15 && f[r][pRight + 1] === 6) f[r][pRight + 1] = 0;
        for (let w = 1; w <= widen; w++) {
          if (pLeft - w >= 0 && f[r][pLeft - w] === 0) f[r][pLeft - w] = 4;
          if (pRight + w < 16 && f[r][pRight + w] === 0) f[r][pRight + w] = 4;
        }
        const nl = pLeft - widen - 1;
        const nr = pRight + widen + 1;
        if (nl >= 0 && f[r][nl] === 0) f[r][nl] = 6;
        if (nr < 16 && f[r][nr] === 0) f[r][nr] = 6;
      }
    }
  }

  return f;
}

// Pre-compute all female frame sets
export const FEMALE_IDLE_TYPING_UP_FRAMES = IDLE_TYPING_UP_FRAMES.map(f => makeFemaleFrame(f));
export const FEMALE_WALKING_DOWN_FRAMES = WALKING_DOWN_FRAMES.map(f => makeFemaleFrame(f));

export const FEMALE_ANIMATION_FRAMES: Record<string, number[][][]> = {};
for (const [key, frames] of Object.entries(ANIMATION_FRAMES)) {
  FEMALE_ANIMATION_FRAMES[key] = frames.map(f => makeFemaleFrame(f));
}
